import { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { history } from '../../helpers/history';
import { loginActions } from '../../action/loginAction';
import { alertActions } from '../../action/AlertAction';
import RenderCasino from './RenderCasino';

class SliderImageInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sratchflxfog: 1,
            ScratchCards: [
                { 'img_path': "./assets/img/european-scratch-cards/GoldenMatch.png" },
                { 'img_path': "./assets/img/european-scratch-cards/LuckyOne.png" },
                { 'img_path': "./assets/img/european-scratch-cards/TreasureTicket.png" }
            ],
            OnlineSlots: [
                { 'id': 40, 'url': "/roulette", 'img_path': process.env.REACT_APP_CDN_URL + "assets/icons/roulette.png" },
                { 'id': 10, 'url': "/rouletteinstant", 'img_path': process.env.REACT_APP_CDN_URL + "assets/icons/roulette-instant.png" },
                { 'id': 11, 'url': "poker", 'img_path': process.env.REACT_APP_CDN_URL + "assets/icons/poker.png" },
                { 'id': 40, 'url': "/roulette", 'img_path': process.env.REACT_APP_CDN_URL + "assets/icons/roulette.png" },
                { 'id': 10, 'url': "/rouletteinstant", 'img_path': process.env.REACT_APP_CDN_URL + "assets/icons/roulette-instant.png" },
                { 'id': 40, 'url': "/roulette", 'img_path': process.env.REACT_APP_CDN_URL + "assets/icons/roulette.png" },
                { 'id': 10, 'url': "/rouletteinstant", 'img_path': process.env.REACT_APP_CDN_URL + "assets/icons/roulette-instant.png" }
                
            ],
            InstantTableGames: [
                { 'img_path': "./assets/img/slots/game-5.png" },
                { 'img_path': "./assets/img/slots/game-6.png" },
                { 'img_path': "./assets/img/slots/game-7.png" },
                { 'img_path': "./assets/img/slots/game-8.png" },
                { 'img_path': "./assets/img/slots/game-9.png" },
            ],
            Tabnumber: 1,
            SwitchControl: false
        }
    }

    componentDidMount() {
        if (window.ScratchCard) {
            window.ScratchCard()
        }
        this.setjsonvideourl();
    }

    setjsonvideourl = () => {
        let hbanner = 0;
        let hbanner_old = localStorage.getItem('videovers');
        if (this.props.appvariables.bVersion) {
            let hbannerVer = this.props.appvariables.bVersion.split("~")
            if (hbannerVer.length > 0) {
                hbanner = hbannerVer[4];
                localStorage.setItem('videovers', hbanner);
            }
        }
        if (hbanner_old != hbanner) {
            var s = process.env.REACT_APP_CDN_URL + 'web/HomeWinnerVideo.json' + "?V" + hbanner;
            fetch(s).then(response => response.json()).then(data => {
                localStorage.setItem('videourl', JSON.stringify(data));
                this.setState({ VideoSecion: data })
                console.log("data video url", data)
                setTimeout(() => {
                    if (window.HomePageVideoSlider)
                        window.HomePageVideoSlider()
                }, 300);
            })
        } else {
            let Videourl = JSON.parse(localStorage.getItem('videourl'));
            this.setState({ VideoSecion: Videourl })
            console.log("data video url", Videourl)
            // alert('fetch')
            setTimeout(() => {
                if (window.HomePageVideoSlider)
                    window.HomePageVideoSlider()
            }, 300);
        }
    }

    showMsg = (msg, flag) => {
        this.props.alertError(msg);
    }


    SelectTab = (Tabid) => {
        this.setState({ Tabnumber: Tabid })
    }

    HandleCheckBox = (e) => {
        this.setState({ SwitchControl: e.target.checked });
        this.state.sratchflxfog = 0;
        setTimeout(() => {            
            this.setState({ sratchflxfog: 1 });
            //this.state.sratchflxfog=1;
        }, 10);
    }

    changeTab = (tabid) => {
        localStorage.setItem('tabId', tabid);
        history.push('/generalinfo');
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <div class="homeHead">
                    <h2 class="headding1">{t('lblasiangame')}</h2>
                    <div class="quickBetInr">
                        <label for="switch" class="switchbtn">
                            <input type="checkbox" id="switch" name='SwitchControl' checked={this.state.SwitchControl} value={this.state.SwitchControl} onChange={(e) => { this.HandleCheckBox(e) }} />
                            <span class="sliderbtn"></span>
                        </label>    
                        <p>{t('lblinterscratch')}</p>
                    </div>

                    {this.state.sratchflxfog==1 && <div class="pBrDnDls">
                        <ul class="slides">
                            <RenderCasino renderkey={5} SwitchControl={this.state.SwitchControl} />
                            {/* {this.state.ScratchCards && this.state.ScratchCards.length > 0 && this.state.ScratchCards.map((x1, inx1) =>
                                        <li>
                                            <a>
                                                <img src={x1.img_path} />
                                            </a>
                                        </li>
                                    )} */}
                        </ul>
                    </div>
                    }

                </div>
                <>
                    <h2 class="headding1">{t('lblonlslot')}</h2>
                    <div class="slotGmaes">
                        <a class="viewAll" onClick={() => { history.push('/Instant') }}>{t('lblviewall')}</a>
                        <ul>
                            <RenderCasino renderkey={1} />
                        </ul>
                    </div>
                </>

                
                    <>
                        <h2 class="headding1">{t('lblinstantable')}</h2>
                        {/* <div class="insTabs">                            
                            <a onClick={() => { this.SelectTab(1) }} className={`${this.state.Tabnumber == 1 ? "active" : ""}`} >Roulette</a>
                            <a onClick={() => { this.SelectTab(2) }} className={`${this.state.Tabnumber == 2 ? "active" : ""}`} >Poker</a>
                             <a onClick={() => { this.SelectTab(3) }} className={`${this.state.Tabnumber == 3 ? "active" : ""}`} >Card Games</a>
                            <a onClick={() => { this.SelectTab(4) }} className={`${this.state.Tabnumber == 4 ? "active" : ""}`} >Bingo</a> 
                        </div> */}
                        <div class="slotGmaes slotGmaes2"> 
                            {/* <ul > */}
                                 <RenderCasino renderkey={7}/>
                                {/* {this.state.OnlineSlots && this.state.OnlineSlots.length > 0 && this.state.OnlineSlots.filter(a => a.id != 11).map((x1, inx1) =>
                                    <li>
                                        <a>
                                            <img onClick={() => history.push(x1.url)} src={x1.img_path} />
                                        </a>
                                    </li>
                                )} */}
                            {/* </ul> */}
                        </div>
                    </>
                

                {this.state.VideoSecion && this.state.VideoSecion.length > 0 &&
                    <>
                        <h2 className="headding1">{t('lblwinnersec')}</h2>
                        <div className="slotGmaes slotGmaes3">
                            <a onClick={() => { this.changeTab(16) }} class="viewAll">{t('lblviewall')}</a>
                            <ul>
                                {this.state.VideoSecion && this.state.VideoSecion.length > 0 && this.state.VideoSecion.map((x, inxd) =>
                                    <>
                                        <li key={`k_${inxd}`}>
                                            <iframe
                                                width="100%"
                                                height="180"
                                                title="YouTube video player"
                                                // frameborder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                className="rounded-md iframeborder"
                                                allowFullScreen
                                                src={x.videoUrl + '&rel=0'}
                                            >
                                            </iframe>
                                        </li>
                                    </>
                                )}
                            </ul>
                            {/* <a className="hmMoreVideosBtn" onClick={() => { history.push('/winnersstory') }} >{t('lblmorevideos')}</a> */}
                        </div>
                    </>}
                <h2 class="headding1">{t('lblwhyplaygulf')}?</h2>
                <div class="whyPlay">
                    {/* <a href="#" class="viewAll">View All</a> */}
                    <ul>
                        <li>
                            <div class="whyPlayCont">
                                <img src="./assets/img/icons/guaranteed.png" />
                                <h4 style={{ textTransform: "lowercase" }}>{t('lblguranteed')}</h4>
                                <p dangerouslySetInnerHTML={{ __html: t(`lblcustomermsg`) }} ></p>
                            </div>
                        </li>
                        <li>
                            <div class="whyPlayCont">
                                <img src="./assets/img/icons/prizes.png" />
                                <h4>{t('lblprizes')}</h4>
                                <p>{t('lblcreditac')}</p>
                            </div>
                        </li>
                        <li>
                            <div class="whyPlayCont">
                                <img src="./assets/img/icons/safe.png" />
                                <h4>{t('lblsafe')}</h4>
                                <p>{t('lblsafeinfomsg')}</p>
                            </div>
                        </li>
                        <li>
                            <div class="whyPlayCont">
                                <img src="./assets/img/icons/premium.png" />
                                <h4>{t('lblpremservice')}</h4>
                                <p>{t('lblconcern')}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </>
        )
    }

}

function mapStateToProps(state) {
    const { latestResult } = state.gameReducer;
    const { user, appvariables } = state.loginReducer;
    return { user, latestResult, appvariables };
}
const mapActionToProps = {
    getBalance: loginActions.getBalance,
    alertError: alertActions.error,
}

export default connect(mapStateToProps, mapActionToProps)(withTranslation()(SliderImageInfo))


